import type { AnchorHTMLAttributes, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface NeonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    variant?: 'primary' | 'outline' | 'ghost'
    size?: 'sm' | 'md' | 'lg'
}

const VARIANTS = {
    primary: 'bg-neon-cyan text-primary-foreground shadow-[0_0_0_1px_rgb(46_242_255/0.6),0_0_24px_rgb(46_242_255/0.45)] hover:bg-[#7af8ff] hover:shadow-[0_0_0_1px_rgb(46_242_255/0.9),0_0_38px_rgb(46_242_255/0.7)]',
    outline: 'border border-neon-pink/55 bg-neon-pink/5 text-neon-pink shadow-[0_0_18px_rgb(255_61_206/0.15)] hover:border-neon-pink hover:bg-neon-pink/15 hover:shadow-[0_0_30px_rgb(255_61_206/0.35)]',
    ghost: 'text-foreground/80 hover:bg-white/5 hover:text-foreground'
}

const SIZES = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-5 text-sm',
    lg: 'h-12 px-7 text-base'
}

export const neonButtonClasses = (variant: keyof typeof VARIANTS = 'primary', size: keyof typeof SIZES = 'md'): string => {
    return cn(
        'inline-flex items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon-cyan focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        VARIANTS[variant],
        SIZES[size]
    )
}

const NeonLink: FC<NeonLinkProps> = ({
    variant = 'primary',
    size = 'md',
    className,
    children,
    ...props
}): ReactNode => {
    return (
        <a className={cn(neonButtonClasses(variant, size), className)} {...props}>
            {children}
        </a>
    )
}

export default NeonLink
